<template>
  <div v-if="!isLoading">
    <course-home v-if="canLearn && (currentCourse.id || projectCourse.courseId)"></course-home>
    <course-adv v-if="!canLearn && (currentCourse.id || projectCourse.courseId)"
                :isHadCourse="isHasCourse"></course-adv>

    <no-course-page v-else-if="(!proId && currentCourse && !currentCourse.id)"
    tipTxt="当前课程不存在或尚未发布">
    </no-course-page>

    <no-course-page v-else-if="(proId && projectCourse && !projectCourse.courseId)"
                    tipTxt="当前项目课程不存在或尚未发布">
    </no-course-page>
  </div>
</template>

<script>
  import CourseHome from '@/page/course-home/courseHome'
  import CourseAdv from '@/page/course/courseAdv'
  import NoCoursePage from '@/page/course/noCoursePage'
  import {mapState} from "vuex";
  import Cookies from "js-cookie";

  export default {
    name: "indexCourse",
    data() {
      return {
        canLearn: false,
        currentCourse: {},
        projectCourse: {},
        currentUser: {},
        courseId: '',
        isHasCourse: false,
        isBuyCourse: false,
        proId:'',
        isLoading : false,
    }
    },

    computed: {
      ...mapState({
        paymentTypeEnum: state => state.PaymentTypeEnum
      }),
    },
    components: {
      CourseHome,
      CourseAdv,
      NoCoursePage
    },
    mounted() {
      this.courseId = this.$route.params.id;
      this.proId = this.$route.query['proId'];
      if (Cookies.get('u_info')) {
        this.currentUser = JSON.parse(Cookies.get('u_info'))
      } else {
        this.currentUser = {};
      }
      if (this.proId) {
        this.isProjectCourse = true;
        this.getProjectCourse();
      } else {
        this.isProjectCourse=false;
        this.getCourseHome();
      }
    },
    methods: {
      getProjectCourse() {
        this.isLoading = true;
        this.$store.dispatch('getProjectCourseForLearner', {id: this.courseId, proId: this.proId}).then((res) => {
          this.projectCourse = res;
          console.log(this.projectCourse)
          this.isLoading = false;
          if(res && res.course) {
            this.currentCourse = res.course;
          }
          // if (sessionStorage.getItem('currentCourse')) {
          //   sessionStorage.removeItem('currentCourse')
          // }
          // sessionStorage.setItem('currentCourse', JSON.stringify(this.currentCourse));
          this._isCanLearn();
        }, (error) => {
          this.$router.push('/404');
        })
      },
      getCourseHome() {
        this.isLoading = true;
        this.$store.dispatch('getCourseForLearner', {id: this.courseId}).then((res) => {
          if(res) {
            this.currentCourse = res;
          }
          this.isLoading = false;
          // if (sessionStorage.getItem('currentCourse')) {
          //   sessionStorage.removeItem('currentCourse')
          // }
          // sessionStorage.setItem('currentCourse', JSON.stringify(this.currentCourse));
          this._isCanLearn();
        }, (error) => {
          this.$router.push('/404');
        })
      },

      // 判断是否拥有课程
      // 课程PREVIEW直接学习 - 分配和制作也可以
      // 购买的课程 也是拥有的
      _isHasCourse() {
        this._isBuyCourse();
        if (this.currentCourse.payment === this.paymentTypeEnum.preview || this.isBuyCourse ||
          (this.currentCourse.userCourse &&
            (this.currentCourse.userCourse.payment === this.paymentTypeEnum.share ||
              this.currentCourse.userCourse.payment === this.paymentTypeEnum.creator))) {
          this.isHasCourse = true;
        } else {
          this.isHasCourse = false;
        }
      },
      //判断是否是支付课程
      _isBuyCourse() {
        if (this.currentCourse.userCourse && this.currentCourse.userCourse.payment && this.currentCourse.userCourse.payment !== 'none') {
          this.isBuyCourse = true;
        } else {
          this.isBuyCourse = false;
        }
      },
      /// 判断是否可以学习
      _isCanLearn() {
        this._isHasCourse();
        /// 被拒绝直接返回false
        if (this.currentCourse &&
          this.currentCourse.userCourse &&
          !this.currentCourse.userCourse.available) {
          this.canLearn = false;
          return;
        }

        if (this.isProjectCourse) {
          console.log(this.projectCourse.course.userCourse);
          if (this.projectCourse.userProjectCourse && this.projectCourse.course && this.projectCourse.course.userCourse
            && this.isHasCourse ) {
            console.log(4567777777777777777777);
            this.canLearn = true;
          } else {
            console.log(123456);
            this.canLearn = false;
          }
        } else {
          this.canLearn = this.isHasCourse;
        }

      },

      // choosePage() {
      //   //添加浏览器title
      //   this.$store.commit('SET_BROWHEADERTITLE', {
      //     browserHeaderTitle: this.currentCourse.title
      //   });
      //   if (!this.currentCourse.available || this.currentCourse.deleted) {
      //     this.$router.push('/404');
      //   } else if (this.currentCourse.userCourse && this.currentCourse.userCourse.available) {
      //     if (this.currentCourse.payment === this.paymentTypeEnum.preview) {
      //       this.canLearn = true
      //     } else if (this.currentCourse.payment === this.paymentTypeEnum.free
      //       || this.currentCourse.payment === this.paymentTypeEnum.charge ||
      //       this.currentCourse.payment === this.paymentTypeEnum.solely) {
      //       if ((this.currentCourse.userCourse !== null && this.currentCourse.userCourse.payment !== null && this.currentCourse.userCourse.payment.isNotEmpty)
      //         && this.currentCourse.userCourse.payment === this.paymentTypeEnum.free || this.currentCourse.userCourse.payment === this.paymentTypeEnum.charge ||
      //         this.currentCourse.userCourse.payment === this.paymentTypeEnum.solely || this.currentCourse.userCourse.payment === this.paymentTypeEnum.share ||
      //         this.currentCourse.userCourse.payment === this.paymentTypeEnum.creator) {
      //         this.canLearn = true
      //       } else {
      //         this.canLearn = false;
      //       }
      //     } else {
      //       this.canLearn = false;
      //     }
      //   } else {
      //     this.canLearn = false;
      //   }
      // }
    },

  }
</script>

<style scoped>

</style>
